<template>
    <div class="model">
        <!-- 搜索栏 -->
        <div class="search">
            <el-input
                @clear="resetSearch"
                @keydown.native.prevent.enter="searchHandle"
                v-model="searchInfo">
                <i slot="prefix"
                    class="el-icon-circle-close close_icon"
                    v-if="searchInfo.length > 0"
                    @click="resetSearch"
                ></i>
                <i slot="prefix" @click="searchHandle">
                    <div class="search_icon">
                        <img style="cursor: pointer;" src="../../assets/image/资源 232.png">
                    </div>
                </i>
            </el-input>
        </div>
        <!-- 筛选 -->
        <div class="category">
            <div class="sort">
                <span  style="font-size: 1rem;">排序：</span>
                <el-radio v-model="sortType" label="1" @change="changeSort">热门模型</el-radio>
                <el-radio v-model="sortType" label="2" @change="changeSort">最新发布</el-radio>
                <!-- <div v-for="(item, index) in sorts" :key="index" class="item">{{ item.name }}</div> -->
            </div>
            <div class="label">
                <span style="font-size: 1rem;">标签：</span>
                <el-autocomplete class="inline-input" v-model="tagValue" :fetch-suggestions="querySearch" placeholder="请输入内容"
                    @select="labelHandle" @keydown.native.enter="selectTags"
                ></el-autocomplete>
                <!-- <div v-for="(item, index) in categories" :key="index" class="item">{{ item.name }}</div> -->
            </div>
            <div class="scale">
                <span  style="font-size: 1rem;">格式：</span>
                <el-select v-model="value" popper-class="labelSelect2" placeholder="请选择" @change="scaleHandle" :popper-append-to-body="false">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="radio">
                <el-radio v-model="modelType" label="1" @change="changeRadio">官方模型</el-radio>
                <el-radio v-model="modelType" label="2" @change="changeRadio">用户模型</el-radio>
            </div>
        </div>
        <!-- 模型列表 -->
        <div class="model_container">
            <div class="model_list">
                <div v-for="(item, index) in industrialModel" :key="index" style="cursor:pointer;">
                    <ModelShowFrame :name="item.name" :model="item.thumbnail" 
                                    :user="item.nickname" :userIcon="item.avatar" 
                                    :id="item.id" :type="modelType" :isModelCollection="item.isCollected"></ModelShowFrame>
                </div>
            </div>
            <div class="model_page">
                    <el-pagination
                        background
                        :current-page.sync="currentElPage"
                        :total="total"
                        :page-size="size"
                        @size-change="handleSizeChange"
                        @current-change="currentChange"
                        :hide-on-single-page="valuePage"
                        layout="prev, pager, next"
                        >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import ModelShowFrame from '../../components/modelShowFrame/index'
import { getAllTagType, getAllNormalModel, getAllUserModel, getAllTag, getAllModelByPage } from '../../util/index'
export default {
    data(){
        return{
            searchInfo:'',
            industrialModels: [],
            value:'',
            name: '',
            valuePage:false,
            tagValue: null,
            modelImage:'../../assets/model.jpg',
            userImage:"../../assets/h1.jpg",
            modelType: "1",  // 模型类型 ，1 官方模型 2 用户模型
            sortType: '1',   // 排序类型
            hotSort: '1',   // 热度排序
            timeSort: '1',  // 时间排序
            totalModels:0,
            totalPages: 0,
            currentElPage: 1,  //当前页
            options: [
            {
                value: 0,
                label: '全部格式'
            }, 
            {
                value: 'fbx',
                label: 'FBX'
                }, {
                value: 'obj',
                label: 'OBJ'
                }, {
                value: 'glb',
                label: 'GLB'
                }
            ],
            categories:[],
            sortBy: 'viewsCount',
            sorts:[
                {
                    name:'热门模式',
                },
                {
                    name:'最新发布',
                }
            ],
            industrialModel:[],
            total: 1,
            size: 5
        }
    },
    components:{
        ModelShowFrame
    },
    beforeMount(){
        // this.industrialModel = industrialModels.slice(0, 15)
        // console.log(industrialModels)
    },
    mounted(){
        this.getAllTags()
        this.getAllModels()
    },
    methods:{
        selectTags(){
            this.currentElPage = 1
            this.getAllModels()
        },
        getAllModels(){
            let modelObj = {
                isCommon: this.modelType === '1' ? true : false,
                sortBy: this.sortBy,
                current: this.currentElPage,
                size: this.size
            }
            if(this.tagValue) modelObj.tag = this.tagValue
            if(this.value) modelObj.format = this.value
            if(this.searchInfo) modelObj.name = this.searchInfo
            let token = window.localStorage.getItem('userToken')
            getAllModelByPage(modelObj, token).then(res=>{
                if(res.code === 200){
                    this.industrialModel = res.data.records
                    this.total = res.data.total
                    this.currentElPage = res.data.current
                    // this.totalPages = Math.ceil(res.data.total / 15)
                    // this.industrialModels.forEach(item=>{
                    //     if(item.thumbnail.slice(-3) === 'dds'){
                    //         this.industrialModels.splice(this.industrialModels.indexOf(item), 1)
                    //     }
                    // })
                    // this.industrialModel = this.industrialModels.slice(0, 15)
                    // this.totalModels = res.data.total
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        querySearch(queryString, cb){
            let categories = this.categories
            var result = queryString ? categories.filter(this.createFilter(queryString)) : categories
            cb(result)
        },
        createFilter(queryString){
            return (categories) => {
                return (categories.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
            }
        },
        getAllTags(){
            let token = window.localStorage.getItem('userToken')
            getAllTag({}, token).then(res=>{
                if(res.code === 200){
                    this.categories = res.data
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        changeRadio(val){
            this.modelType = val
            this.currentElPage = 1
            this.getAllModels()
        },
        changeSort(val){
            if(val === '1'){
                this.sortBy = 'viewsCount'
                this.currentElPage = 1
                this.getAllModels()
            }else if(val === '2'){
                this.currentElPage = 1
                this.sortBy = 'createdAt'
                this.getAllModels()
            }
        },
        scaleHandle(val){
            this.value = val
            this.currentElPage = 1
            this.getAllModels()
        },
        labelHandle(val){
            this.tagValue = val.value
            console.log(val);
            this.getAllModels()
        },
        currentChange(page){
            this.currentElPage = page
            this.getAllModels()
        },
        handleSizeChange(val){
            this.pageSize = val
            this.getAllModels()
        },
        searchHandle(){
            this.getAllModels()
        },
        resetSearch(){
            this.searchInfo = ''
            this.getAllModels()
        }
    }
}
</script>

<style scoped lang="less">
// 下拉框位置
::v-deep .labelSelect{
    background-color: #969696;
    border: none;
    border-radius: 10px;
    top: 26px !important;
    color: #000;
}
::v-deep .labelSelect2{
    background-color: #969696;
    border: none;
    border-radius: 5px;
    top: 26px !important;
    color: #000;
}
::v-deep .el-popper[x-placement^=bottom] .popper__arrow{
    display: none;
}
::v-deep .el-select-dropdown__item{
    color: #383838;
}
::v-deep .el-select-dropdown__item.selected{
    background-color: #c0c0c0;
    color: #fff;
    font-weight: normal;
    border-radius: 6px;
}
::v-deep .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #c0c0c0;
    color: #fff;
    width: 100%;
    margin: 0 auto;
    border-radius: 6px;
}
// 分页器
::v-deep .el-pagination.is-background .btn-next, ::v-deep .el-pagination.is-background .btn-prev, ::v-deep .el-pagination.is-background .el-pager li{
    background-color: #8C8C8C;
    color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #54ceec;
    color: #000;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #000;
}

::v-deep .el-input__prefix{
    right: 5px;
    left: auto;
    display: flex;
    align-items: center;
}

::v-deep .el-radio__input.is-checked+.el-radio__label{
    color: #54d1ef;
}

::v-deep .el-radio__input.is-checked .el-radio__inner{
    border-color: #54d1ef;
    background: #54d1ef;
}

// ::v-deep .el-radio__inner:hover{
//     border-color: #54d1ef;
// }

::v-deep .el-radio{
    color: #fff;
}

::v-deep .search .el-input__inner{
    height: 50px;
    // background-color: #626262;
}
::v-deep .search .el-input__inner{
    background-color: #5A5A5A;
    border: none;
    color: #fff;
}
.model{
    // min-height: 35vw;
    // position: static;
    // background-color: #000;
    background:repeating-linear-gradient(to left,#1E1E1E,#191919);
    .search{
        padding-top: 4rem;
        width: 60%;
        max-width: 1200px;
        margin: 0 auto;
        .custom-clear-icon {
            position: absolute;
            right: 100px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            /* 其他样式 */
        }
        .close_icon{
            padding: 0 1rem;
            cursor: pointer;
        }
        .search_icon{
            padding: 0 1rem;
            border-left: 2px solid;
        }
        ::v-deep .el-input {
            font-size: 20px;
        }
        ::v-deep .el-input__inner{
            border-radius: 10px;
        }
        ::v-deep .el-input .el-input__prefix:nth-of-type(2) {
            right: 300px;
        }
    }
    .category{
        margin: 2rem auto;
        width: 70%;
        max-width: 1500px;
        padding: 2rem 0;
        border-top: 1px solid #363636;
        border-bottom: 1px solid #363636;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .label{
            display: flex;
            align-items: center;
            span{
                font-size: 1.3rem;
                font-weight: 500;
                margin-right: 0.6rem;
            }
            .item{
                border: 0.5px solid #dcdcdc;
                padding: 4px 1rem;
                border-radius: 15px;
                cursor: pointer;
                margin-right: 2rem;
            }
            .labelSelect{
                background-color: #54d1ef;
            }
            .item:hover{
                background-color: #54d1ef;
                color: #000;
            }
            ::v-deep .el-input__inner{
                background-color: #666666;
                border: none;
                color: #999999;
                border-radius: 15px;
                height: 2rem;
            }
            ::v-deep .el-input__icon{
                line-height: 2rem;
            }
        }
        .scale{
            display: flex;
            align-items: center;
            span{
                font-size: 1.3rem;
                font-weight: 500;
                margin-right: 0.6rem;
            }
            ::v-deep .el-input__inner{
                background-color: #666666;
                border: none;
                color: #999999;
                border-radius: 15px;
                height: 2rem;
            }
            ::v-deep .el-input__icon{
                line-height: 2rem;
            }
        }
        .sort{
            display: flex;
            align-items: center;
            span{
                font-size: 1.3rem;
                font-weight: 500;
                margin-right: 0.6rem;
            }
            .item{
                border: 0.5px solid #dcdcdc;
                padding: 4px 1rem;
                border-radius: 15px;
                cursor: pointer;
                margin-right: 2rem;
            }
            .item:hover{
                background-color: #54d1ef;
                color: #000;
            }
        }
    }
}
.model_container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background:repeating-linear-gradient(to left,#1E1E1E,#171717);
    .model_sort{
        color: #fff;
    }
    .model_list {
        width: 80%;
    }
}
.model_page{
    margin: 0 auto;
    padding: 4rem 0;
    // background-color: #54d1ef;
}
</style>